// extracted by mini-css-extract-plugin
export default {"userSelectButton":"select-employee_userSelectButton__nvHMR","selectEmployeeModal":"select-employee_selectEmployeeModal__zpZ+q"};